module.exports = __webpack_public_path__ + "static/media/ic_setting.18aa2c30.svg";